module.exports = __webpack_public_path__ + "static/media/filter.afaa68fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/filter.svg
// module id = 522
// module chunks = 0